<template>
  <div class="compressed-content">
    <h3 class="page-question">Are you on a statin to lower your LDL?<br /><i>(Any of the following lovastatin, simvastatin, pravastatin, atorvastatin, rosuvastatin, pitivastatin, Pravachol, Zocor, Lipitor, Crestor, Livalo)</i></h3>
    <v-form-group class="card-selector page-buttons" :validator="$v.isOnStatinToLowerLDL">
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.isOnStatinToLowerLDL" name="statin"
                    :value="true">
        Yes
      </b-form-radio>
      <b-form-radio v-model="survey.bloodBiochemistry.cholesterol.isOnStatinToLowerLDL" name="statin"
                    :value="false">
        No
      </b-form-radio>
    </v-form-group>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { createNamespacedHelpers } from 'vuex';
  const { mapState } = createNamespacedHelpers('survey');
  import { required } from "vuelidate/lib/validators";

  export default {
    mixins: [formMixin],

    validations: {
      isOnStatinToLowerLDL: {
        required
      }
    },

    computed: {
      ...mapState(["survey"]),

      isOnStatinToLowerLDL() { return this.survey.bloodBiochemistry.cholesterol.isOnStatinToLowerLDL; }
    }
  };
</script>